import { Formation } from "../types"

export const pos66mzona: Formation = {
  id: "pos66mzona",
  name: "M Zone",
  category: "6 - 6",
  snapshots: [
    {
      players: [
        {
          x: 7.252919806659293,
          y: 8.352610616558627
        },
        {
          x: 12.914568318830739,
          y: 6.665273832733629
        },
        {
          x: 1.9322646857732229,
          y: 6.677069223055276
        },
        {
          x: 13.089219124086442,
          y: 3.209361141300543
        },
        {
          x: 6.826825742368345,
          y: 3.266930146029346
        },
        {
          x: 0.45096510655848643,
          y: 3.1735612329189067
        }
      ],
      opponents: [
        {
          x: 10.883096528594496,
          y: 7.740889463800683
        },
        {
          x: 3.298992781371341,
          y: 7.2050272988304584
        },
        {
          x: 11.333221143861541,
          y: 3.909544002482826
        },
        {
          x: 8.244929487987232,
          y: 3.53833259391101
        },
        {
          x: 5.476911501502763,
          y: 3.7725767730384745
        },
        {
          x: 1.9366800542943081,
          y: 3.5785419824160414
        }
      ],
      ball: {
        x: 8.426150815318847,
        y: 8.307662617490854
      },
      goalkeepers: [
        {
          x: 7.039412704704768,
          y: 1.0483728041928018
        }
      ]
    }
  ]
}
